import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { VehicleActions } from './actions';
import { VehiclesService } from "@services/apis/vehicles/vehicles.service";

@Injectable()
export class VehicleEffects {
  constructor(
    private actions$: Actions,
    private apiService: VehiclesService
  ) { }

  getVehicleByLicensePlate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.getByLicensePlate),
      switchMap(({ licensePlate }) =>
        this.apiService.getByLicensePlate(licensePlate).pipe(
          map((vehicle) =>
            VehicleActions.getByLicensePlateSuccess({ vehicle })
          ),
          catchError((error: HttpErrorResponse) =>
            of(VehicleActions.error({ error }))
          )
        )
      )
    )
  );
  createVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.create),
      switchMap(({ vehicle }) =>
        this.apiService.create(vehicle).pipe(
          map((vehicle) =>VehicleActions.createSuccess({ vehicle })),
          catchError((error: HttpErrorResponse) =>
            of(VehicleActions.error({ error }))
          )
        )
      )
    )
  );
}
